import React, { useEffect } from "react";
import { createPortal } from "react-dom";

const LOADER_STYLE_ID = "fullscreen-loader-styles";

const injectLoaderStyles = () => {
  if (document.getElementById(LOADER_STYLE_ID)) return;

  const styleSheet = document.createElement("style");
  styleSheet.id = LOADER_STYLE_ID;
  styleSheet.textContent = `
  .loader-container {
    position: fixed;
    inset: 0;
    width: 100%;
    min-height: 100vh;
    min-height: 100dvh;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgb(90 90 90 / 95%);
    z-index: 9999;
    touch-action: none;
  }

  body.loader-scroll-lock {
    overflow: hidden !important;
    position: fixed;
    width: 100%;
    left: 0;
    right: 0;
  }

  .loader {
    width: 50px;
    height: 50px;
    border: 5px solid #f3f3f3;
    border-top: 5px solid #3498db;
    border-radius: 50%;
    animation: loader-spin 1s linear infinite;
  }

  @keyframes loader-spin {
    to { transform: rotate(360deg); }
  }
`;
  document.head.appendChild(styleSheet);
};

const FullScreenLoader = () => {
  useEffect(() => {
    injectLoaderStyles();
    const scrollY = window.scrollY;
    document.body.classList.add("loader-scroll-lock");
    document.body.style.top = scrollY ? `-${scrollY}px` : "";

    return () => {
      document.body.classList.remove("loader-scroll-lock");
      document.body.style.top = "";
      window.scrollTo(0, scrollY);
    };
  }, []);

  return createPortal(
    <div className="loader-container" role="status" aria-label="Loading">
      <div className="loader" />
    </div>,
    document.body
  );
};

export default FullScreenLoader;
